import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getEnvVar } from '@utils/environmentVariables';

import { useFeatureFlags } from '@config';
import { UserCircleIcon } from '@icons';
import { useLogout } from 'hooks/useLogout';

import { useCounterTerminal } from '@hooks/useCounterTerminal';

import { useAppSelector } from '@store';

import { handleUnCommittedData } from '@service/eventService';

const languageNamespace = 'common';

import styles from './userMenu.module.scss';

export const isDeviceMobileElectron = (): boolean => {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Electron/i.test(
      navigator.userAgent,
    )
  ) {
    return true;
  }
  return false;
};

export const UserMenu = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { username } = useAppSelector((state) => state.user);
  const { fadcode } = useAppSelector((state) => state.branchInfo);
  const { logoutForgerock } = useLogout();
  const { t } = useTranslation(languageNamespace);
  const { isFromCT, isElectron } = useCounterTerminal();
  const { configureCtBoUrl } = useFeatureFlags();

  const handleClick = () => {
    setShowMenu(!showMenu);
  };

  const handleMyProfile = async () => {
    // v2Url for now is only present in prod, test1, int
    // so in case when v2Url is not present in other env files it will default to v1URL i.e. NEXT_PUBLIC_BRANCH_HUB_PROFILE
    let v2Url = getEnvVar('NEXT_PUBLIC_BRANCH_HUB_PROFILE_V2');
    v2Url = !!v2Url ? v2Url : getEnvVar('NEXT_PUBLIC_BRANCH_HUB_PROFILE');

    let branchHubUrl =
      configureCtBoUrl === 'V2' ? v2Url : getEnvVar('NEXT_PUBLIC_BRANCH_HUB_PROFILE');
    if (isFromCT === true) {
      branchHubUrl = branchHubUrl?.replace(
        getEnvVar('NEXT_PUBLIC_BRANCH_HUB_BO') ?? '',
        getEnvVar('NEXT_PUBLIC_BRANCH_HUB_CT') ?? '',
      );
      branchHubUrl = branchHubUrl + '&navigatedFromCT=true';
    }
    if (isDeviceMobileElectron()) {
      branchHubUrl = branchHubUrl + '&fullscreen=yes';
    }
    branchHubUrl = branchHubUrl + `&fadcode=${fadcode}`;
    // it will redirect to branch hub page
    if (isElectron) {
      window.location.href = branchHubUrl;
    } else {
      window.open(branchHubUrl);
    }
  };

  const handleLogout = () => {
    handleUnCommittedData(); //To store uncommited data before logout
    logoutForgerock();
  };

  return (
    <div>
      <div className={styles.userMenu} onClick={handleClick} data-testid="usermenu">
        <span>{username}</span>
        <UserCircleIcon className={styles.userIcon} />
      </div>
      {showMenu && (
        <div className={styles.menuOptions}>
          <ul className={styles.headerMenu}>
            <li>
              <a href={'#'} onClick={handleMyProfile}>
                {t('profile')}
              </a>
            </li>
            <li>
              {!isElectron && (
                <a href={'#'} onClick={handleLogout}>
                  {t('logout')}
                </a>
              )}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};
